// src/lib/authedFetch.js
import { supabase } from "../supabaseClient";
import { apiFetch } from "./apiFetch";
import { getCachedSession } from '../contexts/AuthContext';

export async function authedFetch(url, options = {}) {
  // Get current session from centralized auth state (no direct supabase.auth call)
  const session = getCachedSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("No Supabase session token available");
  }

  const method = (options.method || "GET").toUpperCase();
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };

  if (method !== "GET" && method !== "HEAD" && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  return apiFetch(url, {
    ...options,
    method,
    headers,
  });
}
